export default function matchTheSameMembers(includedMembers = []){
    if(!includedMembers.length){
        return []
    }

    const commonIds = includedMembers
        .map(arr => arr.map(item => item.id))
        .reduce((acc, ids) => acc.filter(id => ids.includes(id)));

    return includedMembers[0].filter(item => commonIds.includes(item.id));
}
